import { USER_BETA_FEATURES } from '@/constants'
import { isLocalOrDevEnv } from '@/utils/helpers/env.ts'
import { useKeycloak } from './auth/keycloak'
import { useOnboarding } from './onboarding'
import type { UserMeOrganization } from '@deepcloud/api-deep-admin'

export function useBetaFeatures(org?: MaybeRefOrGetter<UserMeOrganization>) {
  const { hasBetaFeature: hasBetaFeatureUser } = useKeycloak()

  const { isCurrentOrganizationVerifiedStrong } = useOnboarding(
    computed(() => toValue(org) ?? ({} as UserMeOrganization)),
  )

  const canDeepMail = computed(
    () =>
      (isLocalOrDevEnv() ||
        hasBetaFeatureUser(USER_BETA_FEATURES.USER_BETA_FEATURE_DEEPMAIL)) &&
      isCurrentOrganizationVerifiedStrong.value,
  )

  return {
    canDeepMail,
  }
}
